export const compareByAssignedAt = (a, b) =>
  new Date(a.assignedAt ?? 0) - new Date(b.assignedAt ?? 0);
